import { ContextualField, PropertyType } from '../../../../models/';

export const tagDefinitionGuidProperty: ContextualField = {
    modelName: 'tagDefinitionGuid',
    propertyType: PropertyType.ViewModel,
    label: 'Tag',
    placeholder: 'Tag',
    propertyName: 'tagDefinitionGuidProperty',
    required: true,
    icon: 'fa-tag',
    /*isValid: value => {
        return {
            'required': !!value && value !== guidEmpty
        };
    },*/
    messages: [
        { key: 'required', value: 'A tag is required' },
    ],
    extraData: {

    }
};